import type { IPublicClientApplication } from '@azure/msal-browser';
import { env } from '@sib/config';
import { LOGIN_BASE_REQUEST } from './constants';
import { getExtensionTokenFallback } from './extension-utils';

export interface InstanceConfig {
  clientId: string;
  tenantId: string;
  redirectUri?: string;
}

export interface GetTokensOptions {
  instance: IPublicClientApplication;
  scopes?: string[];
  forceRefresh?: boolean;
}

let isFirstTrigger = true;

export const getTokens = async ({
  instance,
  scopes,
  forceRefresh = false,
}: GetTokensOptions) => {
  try {
    const authResult = await instance.acquireTokenSilent({
      ...LOGIN_BASE_REQUEST,
      forceRefresh: isFirstTrigger || forceRefresh,
      refreshTokenExpirationOffsetSeconds: 300,
      ...(scopes && { scopes }),
    });
    isFirstTrigger = false;

    return {
      idToken: authResult.idToken,
      accessToken: authResult.accessToken,
    };
  } catch (error) {
    const activeAccount = instance.getActiveAccount();

    if (!activeAccount) return null;

    const usernameHint = activeAccount.username;

    if (
      error instanceof Error &&
      error.message.includes('interaction_required')
    ) {
      const authResult = env.isExtension
        ? await getExtensionTokenFallback()
        : await instance.acquireTokenRedirect({
            ...LOGIN_BASE_REQUEST,
            ...(usernameHint && {
              loginHint: usernameHint,
            }),
          });

      if (!authResult) return null;

      return {
        idToken: authResult.idToken,
        accessToken: authResult.accessToken,
      };
    }

    return null;
  }
};
